module.exports = __webpack_public_path__ + "static/media/Dashboard-screenshot.806546a4.png";